import { DownloadOutlined, FilePdfOutlined, FileProtectOutlined, FileSearchOutlined, FileTextOutlined, IdcardOutlined, MonitorOutlined, PrinterOutlined, SecurityScanOutlined, UploadOutlined } from "@ant-design/icons";
import { ItemType, MenuItemType } from "antd/es/menu/hooks/useItems";
import { MinvoiceProduct } from "../../model/customModels";
import { Button } from "antd";
import File from "../../components/Body/SearchInvoice/File/File";
import Account from "../../components/Body/SearchInvoice/Account/Index";
import Invoice from "../../components/Body/SearchInvoice/Single/Invoice/Invoice";
import Proof from "../../components/Body/SearchInvoice/Single/Proof/Proof";

const MenuItems: ItemType<MenuItemType>[] = [
    {
        key: "single/invoice",
        title: "Tra cứu hóa đơn",
        label: "Tra cứu hóa đơn",
        icon: <FileTextOutlined />,
    },
    {
        key: "single/proof-of-personal-income-tax-deduce",
        title: "Tra cứu CT khấu trừ thuế TNCN",
        label: "Tra cứu CT khấu trừ thuế TNCN",
        icon: <FileSearchOutlined />
    },
    {
        key: "file",
        title: "Tra cứu theo file",
        label: "Tra cứu theo file",
        icon: <UploadOutlined />
    },
    {
        key: "account",
        title: "Tra cứu theo tài khoản",
        label: "Tra cứu theo tài khoản",
        icon: <IdcardOutlined />
    },
    {
        label: (<a href="https://kiemtrahoadon.vn/" target="_blank">Kiểm tra hóa đơn hợp lệ</a>),
        title: "Kiểm tra hóa đơn hợp lệ",
        key: "kiem-tra-hoa-don",
        icon: <FileProtectOutlined />
    }
]
const ComponentOfMenu = [
    {
        key: "single/invoice",
        node: <Invoice />
    },
    {
        key: "single/proof-of-personal-income-tax-deduce",
        node: <Proof />
    },
    {
        key: "file",
        node: <File />
    },
    {
        key: "account",
        node: <Account></Account>
    },
]
const MInvoiceProducts: MinvoiceProduct[] = [
    {
        href: "",
        imageUrl: "./assets/img/logo/bhxh.png",
        name: "Phần mềm bảo hiểm xã hội",
        content: [
            "Giải pháp kê khai và nộp trực tiếp hồ sơ đến Bảo hiểm xã hội Việt Nam",
            "Hỗ trợ kê khai và tư vấn nghiệp vụ giúp doanh nghiệp thuận tiện khi tham gia BHXH",
        ],
        button: []
    },
    {
        href: "",
        imageUrl: "./assets/img/logo/smi.png",
        name: "Phần mềm quản lý hóa đơn",
        content: [
            "M-Invoice SMI là giải pháp quản lý toàn bộ hóa đơn mua vào, bán ra của doanh nghiệp",
            "Hệ thống hỗ trợ kê khai thuế GTGT, tự động phát hiện hóa đơn không hợp lệ",
        ],
        button: [
            {
                label: "Báo giá",
                href: "https://minvoice.vn/bao-gia/#quanlySMI"
            },
            {
                label: "Demo",
                href: "https://youtu.be/7yLu11cpgEs"
            }
        ]
    },
    {
        href: "",
        imageUrl: "./assets/img/logo/mcontract.png",
        name: "Phần mềm hợp đồng điện tử",
        content: [
            " M-Contract hỗ trợ số hóa quy trình nội bộ, ký kết hợp đồng lao động, hợp đồng thương mai và thanh toán điện tử cho doanh nghiệp.",
        ],
        button: []
    },
    {
        href: "",
        imageUrl: "./assets/img/logo/ca.png",
        name: "Giải pháp ký số",
        content: [
            "M-Invoice cung cấp Chữ ký số USB Token, HSM, remote signning và các giải pháp ký số không sử dụng USB Token đáp ứng nhu cầu ký số mọi lúc mọi nơi mọi thiết bị.",
        ],
        button: []
    },
];
export default { MenuItems, MInvoiceProducts, ComponentOfMenu }